import classNames from 'classnames'
import { ReactNode, useMemo } from 'react'

import { Translation } from 'cng-common/features/translations/components/translation'

import styles from './StyledInputs.module.scss'

interface IProps {
  label?: string
  children: ReactNode
  shortLabel?: boolean
  labelRenderFn?: () => ReactNode
  className?: string
  margin?: 'md' | 'xl'
}

export const StyledInputs = ({
  label,
  children,
  shortLabel,
  labelRenderFn,
  className,
  margin,
}: IProps) => {
  const styleMods = useMemo(
    () => ({
      [styles['marginMd']]: margin === 'md',
      [styles['marginXl']]: margin === 'xl',
    }),
    [margin]
  )

  const getLabelComponent = () => {
    if (labelRenderFn) {
      return <div className={classNames(styles.label)}>{labelRenderFn()}</div>
    }
    if (label) {
      return (
        <div className={classNames(styles.label, { [styles['shortLabel']]: shortLabel })}>
          <Translation text={label} />
        </div>
      )
    }
    return <></>
  }

  return (
    <div className={classNames(styles.root, styleMods, className)}>
      {getLabelComponent()}
      <div className={styles.inputs}> {children}</div>
    </div>
  )
}
